import { useContext } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getAuth } from 'firebase/auth'
import ApiContext from '../../context/ApiContext'
import { Product } from '../../models/Product'

export const ProductsQueryKey = ['products']

interface UseProductsResult {
	products: Product[] | undefined
	isLoading: boolean
	error: Error | null
}

const useProducts = (): UseProductsResult => {
	const auth = getAuth()
	const apiContext = useContext(ApiContext)

	const {
		data: products,
		isLoading,
		error,
	} = useQuery({
		queryKey: ProductsQueryKey,
		queryFn: async (): Promise<Product[]> => {
			const idToken = await auth.currentUser?.getIdToken(true)
			const response = await fetch(`${apiContext.apiUrl}/products`, {
				headers: {
					Authorization: `Bearer ${idToken}`,
				},
			})

			if (!response.ok) {
				throw new Error(await response.text())
			}
			return response.json()
		},
	})

	return { products, isLoading, error }
}
export default useProducts
